import React, { useEffect } from 'react'

import { useGlobalContext } from 'contexts/global'
import { Feedback } from 'components/Feedback'
import { sendError, sendScreenView, sendSelectContent } from 'utils'
import { FEEDBACK_STATUS } from 'constants/feedback'

import { TErrorPageProps } from './types'

export const ErrorPage = ({ onContinue, errorData, client }: TErrorPageProps) => {
  const { setHeaderPage, headerPage } = useGlobalContext()
  const onClick = () => {
    sendSelectContent({
      step: 'access_denied',
      scenario: client ?? 'unidentified',
      element_name: FEEDBACK_STATUS.error.button,
      element_type: 'button',
      parent_name: 'error_page',
    })

    onContinue()
  }

  useEffect(() => {
    setHeaderPage(undefined)
  }, [])

  useEffect(() => {
    const scenario = errorData?.scenario ?? 'unidentified'
    if (!headerPage) sendScreenView({ scenario, step: 'access_denied' })

    if (!headerPage && errorData) {
      sendError(errorData)
    }
  }, [headerPage])

  return <Feedback status="error" onContinue={onClick} />
}
